"use client"; // ✅ Mark as a Client Component

import Link from "next/link";
import Image from "next/image";
import css from "./header.module.css";
import SearchHeader from "../components/search/searchHeader";
import MainMenuItem from "./global-components/main-menu-item";
import MainMenuHamburger from "./global-components/main-menu-hamburger";
import { AiFillHome, AiFillCode } from "react-icons/ai";
import {
  FaPuzzlePiece,
  FaGamepad,
  FaBrain,
  FaGhost,
  FaNewspaper,
} from "react-icons/fa6";

export default function Header({ platform }: { platform: string }) {
  const navMenu = {
    home: {
      title: "Home",
      href: "/",
      display: "HOME",
      icon: AiFillHome,
    },
    apps: {
      title: "Categories",
      href: `/${platform}`,
      display: "categories",
      icon: FaPuzzlePiece,
    },
    games: {
      title: "Games",
      href: `/games/all`,
      display: "GAMES",
      icon: FaGamepad,
    },
    news: {
      title: "News",
      href: `/articles`,
      display: "NEWS",
      icon: FaNewspaper,
    },
  };

  return (
    <header className="bg-white flex justify-between shadow-md flex-row sticky items-start top-0 z-50">
      <Link
        href="/"
        className={
          "relative block mb-2 mt-2 ml-2 max-w-[160px] w-full h-8 max-h-[60px]" +
          css.logo
        }
      >
        <Image
          src="https://strapistaticupload.s3.us-east-1.amazonaws.com/getjar-logo.svg"
          alt="GetJar logo"
          priority
          fill
          className="object-contain"
        />
      </Link>
      <div className="flex flex-row mt-2">
        <SearchHeader isMobile={false} />

        <nav className={"gap-[1.5em] relative sm:gap-1 px-2 " + css.nav}>
          <ul>
            <MainMenuItem
              href={navMenu.home.href}
              display={navMenu.home.display}
              title={navMenu.home.title}
              Icon={AiFillHome}
            />
            <MainMenuItem
              href={navMenu.apps.href}
              display={navMenu.apps.display}
              title={navMenu.apps.title}
              Icon={FaPuzzlePiece}
            />
            <MainMenuItem
              href={navMenu.games.href}
              display={navMenu.games.display}
              title={navMenu.games.title}
              Icon={FaGhost}
            />
            <MainMenuItem
              href={navMenu.news.href}
              display={navMenu.news.display}
              title={navMenu.news.title}
              Icon={FaNewspaper}
            />
            <MainMenuHamburger platform={platform} />
          </ul>
        </nav>
      </div>
    </header>
  );
}
